var $boxMenu = $('.tentsby .box');
var yMoveTo=0, yDiff=0,
updateFrequency = 25, chaseFactor = .07;

function setActiveNav(){
	var scrollPos = window. pageYOffset;
	
	var windowHeight = Math.min(window.innerHeight/2,250);
	var curOffset = scrollPos + windowHeight;
	var curMenuID = 0;
	$('.anchor').each(function(){
		var offset = $(this).offset().top;
		if(curOffset > offset) curMenuID = $(this).attr('id');
	});
	if(curMenuID){
		$boxMenu.find('.h4').removeClass('active');
		$boxMenu.find("a[href='#"+curMenuID+"']").addClass('active');
	}
}

$(document).ready(function() {
	setActiveNav();

	$('.tentsby .side .box').on('click', 'a', function(){
		var sT;
		if($('.header-section.sticky').length)
			sT = $($(this).attr('href')).offset().top - 125;
		else 
			sT = $($(this).attr('href')).offset().top - 220;
	  $('html,body').animate({
	    scrollTop: sT
	  }, 1000);
	  return false;
	});
});

window.addEventListener ("scroll", setActiveNav, false);